import React from "react";
import { RenderWhen, TooltipIcon } from "../../../../../components";
import { enums } from "../../../../../shim/jsbridge";
import { transformPlatformSelectionValues } from "../../../../../utils";
import { RLCSConfigurationProps } from "../../../@types/rldynamicanalysis";
import { GEOLOCATION_TO_LABEL } from "../../geolocationmenuitem/GeolocationMenuItem";

const RLCSConfiguration: React.FC<RLCSConfigurationProps> = ({
  configuration,
  platform,
  geolocation,
  locale,
  sampleName,
  internetSimulation,
  timeout
}) => {
  const locationDisplay = geolocation
    ? GEOLOCATION_TO_LABEL[geolocation]
    : GEOLOCATION_TO_LABEL[enums.geolocations.US];

  const platformKey = Object.keys(enums.platforms).find(
    key =>
      enums.platforms[key] === (platform === "macos11" ? "macos_11" : platform)
  );
  const platformDisplay = platform
    ? transformPlatformSelectionValues(platformKey)
    : "Unknown platform";

  return (
    <div className="flex align-center flex-gap-2 flex-wrap">
      <span>
        <strong>Platform:</strong> {platformDisplay}
      </span>
      <RenderWhen condition={Boolean(configuration)}>
        <TooltipIcon
          icon="info-circle"
          message={configuration}
          data-testid="rlcs_configuration_info"
        />
      </RenderWhen>
      ,
      <span>
        <strong>Locale:</strong> {locale ?? enums.locales.EN_US},
      </span>
      <span>
        <strong>Geolocation:</strong> {locationDisplay},
      </span>
      {sampleName && (
        <span>
          <strong>File Name:</strong> {sampleName},
        </span>
      )}
      {timeout && (
        <span>
          <strong>Timeout:</strong> {timeout} seconds,
        </span>
      )}
      <span>
        <strong>Internet Simulation:</strong>{" "}
        {internetSimulation ? "On" : "Off"}
      </span>
    </div>
  );
};

export default RLCSConfiguration;
